export type UserView = {
  id: number
  visited_at: Date
}

export const RECOMMENDATION_LOCAL_STORAGE_IDENTIFIER = 'lastPagesViewed'

export const ENGAGEMENT_TYPES = ['view'] as const
export type EngagementType = typeof ENGAGEMENT_TYPES[number]
